/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, March 2020
 *
 *****************************************************************************/

import React, { Component } from "react";
import amplifyCustomUi from "aws-amplify-react-custom-ui";
import SignIn from "./components/SignIn";
import Loading from "./components/Loading/Loading";
import Toast from "./components/Toast/Toast";

class App extends Component {
  
  // Called before rendering view first time
  componentWillMount() {
    /**
     * overwrite aws Sign page with custom made
     * Self check if loggedIn or not and render page accordingly
     */
    amplifyCustomUi.setSignIn(SignIn);
  }
  render() {
    return (
      <>
        <Loading />
        <Toast />
      </>
    );
  }
}

export default App;
